module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-open_new-black-ec4ad48c.svg";